import { enumOr, realVec2Or, vec3Or } from '../../../parser/valueParsers';
import { flooredCount } from '../meshCounts';
import { PlaneMeshOrientation } from '../../../godot/scene/planeMesh.js';
export const PLANE_MESH_DEFAULTS = {
    size: { x: 2, y: 2 },
    orientation: PlaneMeshOrientation.FACE_Y,
};
const ORIENTATIONS = Object.values(PlaneMeshOrientation);
export function decodePlaneMesh(properties, defaults = PLANE_MESH_DEFAULTS) {
    return {
        size: realVec2Or(properties.size, defaults.size, 'PlaneMesh size'),
        subdivideWidth: flooredCount(properties.subdivide_width, 0, 0, 'PlaneMesh subdivideWidth'),
        subdivideDepth: flooredCount(properties.subdivide_depth, 0, 0, 'PlaneMesh subdivideDepth'),
        orientation: enumOr(properties.orientation, defaults.orientation, ORIENTATIONS, 'PlaneMesh orientation'),
        centerOffset: vec3Or(properties.center_offset, { x: 0, y: 0, z: 0 }, 'PlaneMesh center_offset'),
    };
}
//# sourceMappingURL=decode.js.map